<template>
  <div>
    <div class="shop_cart container" ref="content">
      <div class="head_box">
        <div class="logo">
          <router-link to="/" target="_blank">
            <img class="img_item cur_pointer" src="@/assets/img/LOGO.png" alt />
          </router-link>
          <h1>买家具多比·多比多实惠</h1>
        </div>
        <el-steps class="steps" :active="0" finish-status="success" :align-center="true">
          <el-step title="我的购物车"></el-step>
          <el-step title="确认订单信息"></el-step>
          <el-step title="付款到账"></el-step>
          <el-step title="确认收货"></el-step>
          <el-step title="评价嗮图"></el-step>
        </el-steps>
      </div>
      <div class="goods_box" ref="goodsBox">
        <div class="head-box">
          <span class="all_goods">全部商品</span>
          <span class="count">{{allShopCartCount}}</span>
        </div>
        <!-- 表头 -->
        <div class="goods_header">
          <el-checkbox class="check_all" v-model="selectAll" @change="selectAllChange">全选</el-checkbox>
          <span class="item item_name">商品</span>
          <span class="item">单价</span>
          <span class="item">数量</span>
          <span class="item">小计</span>
          <span class="item item_action">操作</span>
        </div>
        <!-- 购物车数据 -->
        <div class="goods_item" v-for="(item,index) in list" :key="index">
          <div class="brand">
            <el-checkbox @change="chooseBrand(item)" :disabled="item.disabled" v-model="item.firstCheck">{{'品牌：'+item.goodsBrandName}}</el-checkbox>
          </div>
          <div class="goods" v-for="(v,i) in item.shoppingCartList" :key="i">
            <div class="item img_item">
              <el-checkbox class="checkbox" v-model="v.lastCheck" v-show='v.goodsMixStatus==8' @change="chooseLastCart(item)"></el-checkbox>
              <span class="checkbox" v-show='v.goodsMixStatus!=8'>失效</span>
              <!-- 主图 -->
              <router-link :to="{path:'/goodsDetails/'+v.goodsMixSerNo+'.html'}" target="_blank">
                <img class="img cur_pointer" v-lazy="v.mainPreviewImageFilePath" alt="图片加载失败" />
              </router-link>
            </div>
            <!-- 商品信息 -->
            <div class="item name_item">
              <div class="goods_name">
                <router-link :to="{path:'/goodsDetails/'+v.goodsMixSerNo+'.html'}" target="_blank">
                  <span class="com_link">{{v.goodsName+" "+v.goodsMixName}}</span>
                </router-link>
              </div>
              <div class="goods_no">
                <router-link :to="{path:'/goodsDetails/'+v.goodsMixSerNo+'.html'}" target="_blank">
                  <span class="com_link">商品货号：{{v.goodsMixNo}}</span>
                </router-link>
              </div>
              <!-- 规格属性 -->
              <div class="attr_box">
                <el-button class="attr_btn" type="primary" :disabled='v.goodsMixStatus==8?false:true' @click="openAttrList(v.goodsMixSerNo,v.id,i,index)">修改</el-button>
                <div class="attr_item" v-show="v['attr'+attrItem+'Name']" v-for="attrItem in 4" :key="attrItem">
                  <div class="label">
                    <el-tooltip :open-delay="500" popper-class="new_popper1" :visible-arrow="false" effect="light" :offset="45" :content="v['attr'+attrItem+'Name']" placement="bottom-end">
                      <span>{{v['attr'+attrItem+'Name']}}：</span>
                    </el-tooltip>
                  </div>
                  <div class="value">
                    <el-tooltip :open-delay="500" popper-class="new_popper1" :visible-arrow="false" effect="light" :offset="45" :content="v['attr'+attrItem+'ContentName']" placement="bottom-end">
                      <span>{{v['attr'+attrItem+'ContentName']}}</span>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <!-- 改变规格属性 -->
              <div class="popover" v-show="v.id===currentCartId">
                <attr-list :ref="'attrList'+i+index" @closeAttr='closeAttr'></attr-list>
              </div>
            </div>
            <!-- 单价 -->
            <div class="item">￥{{v.salePrice| priceValue}}</div>
            <!-- 数量 -->
            <div class="item">
              <el-input-number size="mini" v-model="v.goodsCount" @change="editShoppingCart(v.id,v.goodsCount)" :min="1" :max="999" :precision="0"></el-input-number>
            </div>
            <!-- 总价 -->
            <div class="item total_item">￥{{v.goodsCount*v.salePrice | priceValue}}</div>
            <!-- 操作 -->
            <div class="item action_item">
              <span class="cur_pointer del" v-show='v.goodsMixStatus==8' @click="delShoppingCart(v.id)">删除</span>
              <span class="cur_pointer join" v-show='v.goodsMixStatus==8' @click="collection(v.id,v.goodsMixId)">移入我的收藏</span>
            </div>
          </div>
        </div>
        <!-- ------ -->
      </div>
      <div :class="{footer:true,fixed:isFixed}">
        <div>
          <el-checkbox class="check_all" v-model="selectAll" @change="selectAllChange">全选</el-checkbox>
          <span class="item com_link" @click="DelSelectCart">删除选中商品</span>
          <span class="item com_link " @click="selectCollection">移入我的收藏</span>
          <span class="item com_link mr0" @click="clearInValidGoods" v-if="showInValidGoods">清除失效商品</span>
        </div>
        <div class="flex">
          <div class="already">
            已选择
            <span class="num">{{shopGoodsNumber}}</span> 件商品
          </div>
          <div class="total_box">
            <div class="item_total">
              <span>商品总价：</span>
              <span class="total">￥{{totalPrice | priceValue}}</span>
            </div>
            <!-- <div class="item_total">
              <span>优惠：</span>
              <span class="reduce">￥0</span>
            </div> -->
          </div>
        </div>
        <el-button type="primary result" @click="goPlaceOrder">去结算</el-button>
      </div>
    </div>
    <public-footer ref="pubFooter"></public-footer>
  </div>
</template>

<script>
import {
  GetShopCartList,
  EditShopCart,
  DelShopCart,
  AddCollection,
  DeleteInValidGoods,
} from "@/pages/page1/api/modules/shoppingCart";
import AttrList from "@/pages/page1/components/attrList.vue";
export default {
  metaInfo: {
    title: "购物车 - 多比商城",
    meta: [
      {
        name: "keyWords",
        content: "多比购物,家具购",
      },
    ],
  },
  name: "shopCart",
  components: {
    AttrList,
  },
  data() {
    return {
      isFixed: false,
      selectAll: false,
      list: [],
      lastList: [],
      showInValidGoods: false,
      currentCartId: undefined,
    };
  },
  mounted() {
    this.getShoppingCart();
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 购物车数据操作
    getShoppingCart() {
      this.showInValidGoods = false;
      GetShopCartList({}).then((res) => {
        // console.log("获取购物车列表", res);
        res.data.forEach((item, index) => {
          item.firstCheck = true;
          item.disabled = false;
          // 该品牌没有，有效商品
          let have8 = item.shoppingCartList.find((v) => v.goodsMixStatus == 8);
          if (!have8) {
            item.firstCheck = false;
            item.disabled = true;
          }
          item.shoppingCartList.forEach((v) => {
            v.lastCheck = true;
            // 只要有一个为无效商品
            if (v.goodsMixStatus != 8) {
              this.showInValidGoods = true;
            }
          });
        });
        this.list = res.data;
        // 和上一次相比，选中不丢失
        this.list.forEach((item, index) => {
          let resItem = this.lastList.find(
            (lastItem) => lastItem.goodsBrandId === item.goodsBrandId
          );
          if (resItem) {
            item.firstCheck = resItem.firstCheck;
            // 删了有效商品，只剩下无效商品，去掉勾勾
            if (item.disabled) {
              item.firstCheck = false;
            }
            item.shoppingCartList.forEach((v) => {
              let resV = resItem.shoppingCartList.find(
                (lastV) => lastV.id === v.id
              );
              if (resV) {
                v.lastCheck = resV.lastCheck;
              }
            });
          }
        });
        this.lastList = this.list;
      });
    },
    editShoppingCart(id, number) {
      let params = {
        id,
        goodsMixCount: number,
      };
      EditShopCart(params).then((res) => {
        // console.log("更新购物车数量接口", res);
      });
    },
    delShoppingCart(id) {
      this.$confirm("此操作将删除商品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          DelShopCart({ id }).then((res) => {
            // console.log("删除购物车记录接口", res);
            this.getShoppingCart();
            this.$store.commit("SET_SHOPCARTNUM");
          });
        })
        .catch(() => {});
    },
    DelSelectCart() {
      let idArr = this.selectGoods.map((v) => {
        return v.id;
      });
      let id = idArr.join(",");
      if (id) {
        this.delShoppingCart(id);
      } else {
        this.$alert("请至少选中一件商品", "提示", {
          confirmButtonText: "确定",
          type: "warning",
          showClose: false,
        });
      }
    },
    // 移入收藏
    collection(shoppingCartId, goodsMixId) {
      this.$confirm("此操作会将商品移入收藏, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          AddCollection({ shoppingCartId, goodsMixId }).then((res) => {
            // console.log("移入收藏", res);
            this.getShoppingCart();
            this.$store.commit("SET_SHOPCARTNUM");
          });
        })
        .catch(() => {});
    },
    selectCollection() {
      let idArr = this.selectGoods.map((v) => {
        return v.goodsMixId;
      });
      let goodsMixId = idArr.join(",");
      let cartIdArr = this.selectGoods.map((v) => {
        return v.id;
      });
      let shoppingCartId = cartIdArr.join(",");
      if (goodsMixId) {
        this.collection(shoppingCartId, goodsMixId);
      } else {
        this.$alert("请至少选中一件商品", "提示", {
          confirmButtonText: "确定",
          type: "warning",
          showClose: false,
        });
      }
    },
    clearInValidGoods() {
      DeleteInValidGoods().then((res) => {
        // console.log("删除失效商品", res);
        this.$store.commit("SET_SHOPCARTNUM");
        this.getShoppingCart();
      });
    },
    // 全选
    selectAllChange(val) {
      // console.log(val);
      this.list.forEach((item, index) => {
        item.firstCheck = val;
        // 该品牌没有，有效商品
        let have8 = item.shoppingCartList.find((v) => v.goodsMixStatus == 8);
        if (!have8) {
          item.firstCheck = false;
        }
        item.shoppingCartList.forEach((v) => {
          // 只要有一件有效商品，该品牌可全选
          if (v.goodsMixStatus == 8) {
            v.lastCheck = val;
          }
        });
      });
    },
    // 勾选品牌
    chooseBrand(item) {
      // console.log(item);
      item.shoppingCartList.forEach((v) => {
        if (v.goodsMixStatus == 8) {
          v.lastCheck = item.firstCheck;
        }
      });
    },
    // 购物组合
    chooseLastCart(item) {
      // console.log(item);
      // 处理上一层 找到一个false说明没有全选品牌
      let haveFalse = item.shoppingCartList.find(
        (v) => !v.lastCheck && v.goodsMixStatus == 8
      );
      if (!haveFalse) {
        item.firstCheck = true;
      } else {
        item.firstCheck = false;
      }
    },
    // 吸底
    handleScroll() {
      // 内容可视区域的高度加上溢出上下（滚动）的距离
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      // 可视高度
      let clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      // 页面被卷去的上高度
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 页面被卷去的下高度
      let scrollBottom = scrollHeight - clientHeight - scrollTop;
      // 底部footer高度+margin
      let footerHeight = this.$refs.pubFooter.$el.scrollHeight + 70;
      // console.log(scrollBottom, footerHeight);
      scrollBottom <= footerHeight
        ? (this.isFixed = false)
        : (this.isFixed = true);
    },
    goPlaceOrder() {
      if (this.selectBrands.length === 0) {
        this.$alert("请至少选中一件有效商品", "提示", {
          confirmButtonText: "确定",
          type: "warning",
          showClose: false,
        });
        return;
      }
      //选中的商品去订单生成
      // console.log("goods", this.selectBrands);
      let time = new Date().getTime();
      localStorage.setItem(
        "selectGoods_" + time,
        JSON.stringify(this.selectBrands)
      );
      let newUrl = this.$router.resolve({
        path: "/placeOrder",
        query: { id: time, byUrl: "shopCart" },
      });
      window.open(newUrl.href, "_self");
    },
    openAttrList(serNo, id, i, index) {
      // console.log(i,index,'attrList'+i+index);
      this.currentCartId == id
        ? (this.currentCartId = undefined)
        : (this.currentCartId = id);
      if (this.currentCartId) {
        // console.log(this.$refs['attrList'+i+index]);
        this.$refs["attrList" + i + index][0].getGoodsBaseInfo(serNo, id);
      }
    },
    closeAttr(val) {
      this.currentCartId = undefined;
      if (val) {
        this.getShoppingCart();
      }
    },
  },
  computed: {
    // 选中的购物记录
    selectGoods() {
      let arr = [];
      this.list.forEach((item) => {
        item.shoppingCartList.forEach((v) => {
          if (v.lastCheck && v.goodsMixStatus == 8) {
            arr.push(v);
          }
        });
      });
      // console.log(arr);
      return arr;
    },
    // 总价
    totalPrice() {
      let price = 0;
      this.selectGoods.forEach((item, index) => {
        price += item.goodsCount * item.salePrice;
      });
      return price;
    },
    // 购物记录数量
    shopCartNumber() {
      let arr = [];
      this.list.forEach((item) => {
        item.shoppingCartList.forEach((v) => {
          if (v.goodsMixStatus == 8) {
            arr.push(v.id);
          }
        });
      });
      return arr.length;
    },
    // 包含无效商品
    allShopCartCount() {
      let arr = [];
      this.list.forEach((item) => {
        item.shoppingCartList.forEach((v) => {
          arr.push(v.id);
        });
      });
      return arr.length;
    },
    // 选中品牌以及下级商品
    selectBrands() {
      let arr = [];
      this.list.forEach((item, index) => {
        // 先选中品牌
        let resItem = this.selectGoods.find(
          (v) => item.goodsBrandId == v.goodsBrandId
        );
        if (resItem) {
          arr.push({
            goodsBrandId: item.goodsBrandId,
            goodsBrandName: item.goodsBrandName,
            shoppingCartList: [],
          });
        }
      });
      // 再选中商品
      arr.forEach((item) => {
        this.selectGoods.forEach((v) => {
          if (item.goodsBrandId == v.goodsBrandId) {
            item.shoppingCartList.push(v);
          }
        });
      });
      return arr;
    },
    // 购买总数量
    shopGoodsNumber() {
      let goodsNumber = 0;
      this.selectGoods.forEach((item, index) => {
        goodsNumber += item.goodsCount;
      });
      return goodsNumber;
    },
  },
  watch: {
    selectGoods: {
      handler(newV) {
        // console.log(newV.length ,this.shopCartNumber);
        if (newV.length == 0) {
          this.selectAll = false;
          return;
        }
        if (newV.length === this.shopCartNumber) {
          this.selectAll = true;
        } else {
          this.selectAll = false;
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="less" scoped>
.shop_cart {
  color: #1a1a1a;
  font-size: 14px;
  position: relative;
  margin-bottom: 144px;
  .head_box {
    margin-top: 37px;
    margin-bottom: 43px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      cursor: pointer;
      .img_item {
        width: auto;
        height: auto;
      }
      h1 {
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 5.6px;
      }
    }
    .steps {
      width: 630px;
      height: 40px;
      /deep/ .el-step {
        .el-step__head {
          margin-bottom: 12px;
        }
        .el-step__title {
          line-height: 20px;
        }
        .is-success {
          color: rgba(255, 158, 0, 1);
          border-color: rgba(255, 158, 0, 1);
          font-size: 14px;
        }
        .is-process {
          color: rgba(144, 144, 144, 1);
          border-color: rgba(144, 144, 144, 1);
          font-size: 14px;
        }
        .is-wait {
          font-size: 14px;
        }
      }
    }
  }
  .goods_box {
    box-sizing: border-box;
    border: 1px solid rgba(229, 229, 229, 1);
    padding: 32px 24px 25px;
    .head-box {
      margin-bottom: 16px;
      display: flex;
      align-items: flex-end;
      .all_goods {
        font-size: 24px;
        font-weight: bold;
        display: inline-block;
        margin-right: 30px;
      }
      .count {
        color: #ff0000;
        font-size: 20px;
        display: inline-block;
        margin-right: 652px;
      }
      .text {
        margin-right: 20px;
        font-weight: 500;
      }
      .city_box {
        font-size: 14px;
      }
    }
    .goods_header {
      height: 40px;
      line-height: 40px;
      background: rgba(244, 244, 244, 1);
      margin-bottom: 8px;
      padding-left: 18px;
      display: flex;
      .check_all {
        flex: 1;
        /deep/ .el-checkbox__label {
          font-size: 14px;
        }
      }
      .item {
        text-align: center;
        display: inline-block;
        flex: 1;
        &:last-child {
          margin-right: 0px;
        }
      }
      .item_name {
        flex: 2;
      }
      .item_action {
        text-align: left;
        text-indent: 30px;
      }
    }
    .goods_item {
      .brand {
        padding: 10px 0;
        padding-left: 18px;
        border-bottom: 1px solid rgba(229, 229, 229, 1);
      }
      .goods {
        padding-left: 18px;
        margin: 25px 0;
        display: flex;
        align-items: center;
        position: relative;
        .item {
          flex: 1;
          text-align: center;
        }
        .img_item {
          align-self: flex-start;
          text-align: left;
          position: relative;
          .checkbox {
            position: absolute;
            top: 0;
            left: 0;
            width: 32px;
            line-height: 100px;
            display: inline-block;
            font-size: 12px;
          }
          .img {
            margin-left: 32px;
            width: 100px;
            height: 100px;
          }
        }
        .name_item {
          text-align: left;
          flex: 2;
          align-self: flex-start;
          overflow: hidden;
          .goods_name {
            padding-bottom: 10px;
            padding-left: 10px;
            box-sizing: border-box;
            word-break: break-all;
            line-height: 16px;
            a {
              color: #1a1a1a;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }
          }
          .goods_no {
            padding-bottom: 6px;
            padding-left: 10px;
            box-sizing: border-box;
            word-break: break-all;
            font-size: 12px;
            a {
              color: #9c9c9c;
            }
          }
          .attr_box {
            padding: 2px 10px;
            box-sizing: border-box;
            border: 1px solid #ffffff;
            position: relative;
            min-height: 50px;
            &:hover {
              border: 1px dashed @themeColor;
              .attr_btn {
                display: block;
              }
            }
            .attr_item {
              display: flex;
              color: #9c9c9c;
              font-size: 12px;
              margin-bottom: 6px;
              &:last-child {
                margin-bottom: 0px;
              }
              .label {
                width: 80px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                cursor: default;
              }
              .value {
                margin-left: 10px;
                width: 100%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                cursor: default;
              }
            }
            .attr_btn {
              display: none;
              position: absolute;
              top: 0px;
              right: 0px;
              padding: 2px 4px;
              font-size: 12px;
            }
          }
          .popover {
            position: absolute;
            top: 100%;
            left: auto;
            z-index: 99;
            background: #ffffff;
          }
        }
        .total_item {
          color: #ff0000;
          font-weight: 800;
          font-size: 16px;
          flex: 1;
        }
        .action_item {
          flex: 1;
          margin-top: 25px;
          text-align: left;
          color: rgba(255, 170, 32, 1);
          width: auto;
          .del,
          .join {
            padding-left: 30px;
            display: block;
          }
          .del {
            margin-bottom: 8px;
          }
        }
      }
    }
  }
  .footer {
    width: 1280px;
    height: 80px;
    box-sizing: border-box;
    padding-left: 42px;
    padding-right: 226px;
    background: rgba(244, 244, 244, 1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 3;
    position: absolute;
    bottom: -80px;
    left: auto;
    .flex {
      align-items: center;
    }
    .check_all {
      margin-right: 50px;
      /deep/ .el-checkbox__label {
        font-size: 14px;
        font-weight: 500;
        color: rgba(26, 26, 26, 1);
      }
    }
    .item {
      margin-right: 50px;
      display: inline-block;
    }
    .mr0 {
      margin-right: 0px;
    }
    .already {
      margin-right: 50px;
      font-size: 14px;
      .num {
        color: #ff0000;
      }
    }
    .total_box {
      // width: 200px;
      .item_total {
        display: flex;
        justify-content: space-between;
        line-height: 24px;
        .total {
          color: #ff0000;
          font-weight: 600;
        }
        .reduce {
          font-weight: 600;
        }
        span {
          display: inline-block;
        }
      }
    }
    .result {
      width: 164px;
      height: 80px;
      font-size: 16px;
      position: absolute;
      bottom: 0px;
      right: 0px;
    }
  }
  .fixed {
    position: fixed;
    bottom: 0px;
  }
}
</style>